import React, { useEffect, useRef, useState } from "react";
import withAuthority from "../../../../components/Auth/withAuthority";
import Authorities from "../../../../auth/authorities";
import { useRouteMatch } from "react-router";
import moment from "moment";
import { Box, Hidden, useTheme } from "@material-ui/core";
import _ from "lodash";

import { ERROR_MESSAGE_UNEXPECTED_ERROR } from "../../../../utils/consts";
import { fetchAllFilterLocations } from "../../../../services/locationApp/locationFilterService";
import { getCookie } from "../../../../utils/cookies";
import Filter from "../../../../components/common/Filter";
import {
  fetchAllDashboardAverageInfo,
  fetchAllDashboardChannelInfo,
  fetchAllDashboardModeInfo,
  fetchAllDashboardOrdersInfo,
  fetchAllDashboardPaymentInfo,
  fetchAllDashboardPlatformInfo,
  fetchAllDashboardSaleInfo,
  fetchAllDashboardSalesChannelsInfo,
  fetchAllDashboardSalesPlatformsInfo,
  fetchAllDashboardSalesTotalInfo,
  fetchAllDashboardSalesModeInfo,
} from "../../../../services/salesApp/saleDashboardService";
import {
  customerDashboardFilterObject,
  dashboardFilterObject,
  zeroToTwentyThreeList,
} from "../../../../utils/consts/list";
import DashboardDetailsInfoNode from "./DashboardDetailsInfoNode";
import ChartLoading from "./ChartLoading";
import Mode from "./Mode";
import { CustomTheme } from "../../../../types/customTheme";
import DefaultAlert from "../../../../components/alerts/DefaultAlert";
import { enumerateDaysBetweenDates } from "../../../../utils/enumerateDaysBetweenDates";
import { getFilterListFromArrayObject } from "../../../../utils/commonArrayMap";
import { fetchAllUserInfo } from "../../../../services/salesApp/salesService";
import PageHeaderMobile from "../../../../components/common/PageHeader/PageHeaderMobile";
import {
  fetchAllPerformanceDateInfo,
  fetchAllPerformanceInfo,
} from "../../../../services/customerApp/dashboard";
import { fetchLoyaltyProgramInfo } from "../../../../services/customerApp/customerDetails";
import { convertDateToMoment } from "../../../../utils/ConvertDateTimeFormat";

/* Show dashboard total, chart and mode information */
const CustomerDashboardPage: React.FunctionComponent<{}> = () => {
  const [currentDashboardNodeList, setCurrentDashboardNodeList] = useState<any>(
    {},
  );
  const [previousDashboardNodeList, setPreviousDashboardNodeList] =
    useState<any>({});
  const [paymentNodeList, setPaymentNodeList] = useState<any>([]);
  const [previousPaymentNodeList, setPreviousPaymentNodeList] = useState<any>(
    [],
  );
  const [ordersNodeList, setOrdersNodeList] = useState<any>([]);
  const [previousOrdersNodeList, setPreviousOrdersNodeList] = useState<any>([]);
  const [averageNodeList, setAverageNodeList] = useState<any>([]);
  const [previousAverageNodeList, setPreviousAverageNodeList] = useState<any>(
    [],
  );
  const [platformNodeList, setPlatformNodeList] = useState<any>([]);
  const [previousPlatformNodeList, setPreviousPlatformNodeList] = useState<any>(
    [],
  );
  const [modeNodeList, setModeNodeList] = useState<any>([]);
  const [previousModeNodeList, setPreviousModeNodeList] = useState<any>([]);
  const [channelNodeList, setChannelNodeList] = useState<any>([]);
  const [previousChannelNodeList, setPreviousChannelNodeList] = useState<any>(
    [],
  );
  const [salesModeNodeList, setSalesModeNodeList] = useState<any>([]);
  const [previousSalesModeNodeList, setPreviousSalesModeNodeList] =
    useState<any>([]);
  const [salesPlatformsNodeList, setSalesPlatformsNodeList] = useState<any>([]);
  const [previousSalePlatformsNodeList, setPreviousSalesPlatformsNodeList] =
    useState<any>([]);
  const [salesChannelsNodeList, setSalesChannelsNodeList] = useState<any>([]);
  const [previousSalChannelsNodeList, setPreviousSalesChannelsNodeList] =
    useState<any>([]);
  const [locationSelectedList, setLocationSelectedList] = useState([]);
  const [error, setError] = useState("");
  const [openFilterCard, setOpenFilterCard] = useState(false);
  const [
    isLoadingIsLoadingPerformanceTotal,
    setIsLoadingIsLoadingPerformanceTotal,
  ] = useState(true);
  const [isLoadingIsLoadingMode, setIsLoadingMode] = useState(true);
  const [locationSelectorList, setLocationSelectorList] = useState([]);
  const [isOpenSkeletonLoading, setIsOpenSkeletonLoading] = useState(true);
  const [userList, setUserList] = useState<any>([]);
  const [isGetLocationInfo, setIsGetLocationInfo] = useState(false);
  const [filterDetails, setFilterDetails] = useState<any>([]);
  const [previousStartDate, setPreviousStartDate] = React.useState<any>(
    moment().subtract(13, "d").format("YYYY-MM-DD"),
  );
  const [previousEndDate, setPreviousEndDate] = React.useState<any>(
    moment().subtract(7, "d").format("YYYY-MM-DD"),
  );
  const [currentStartDate, setCurrentStartDate] = React.useState<any>(
    moment().subtract(6, "d").format("YYYY-MM-DD"),
  );
  const [currentEndDate, setCurrentEndDate] = React.useState<any>(
    moment().format("YYYY-MM-DD"),
  );
  const [currentSalesTotal, setCurrentSalesTotal] = useState<any>();
  const [previousSalesTotal, setPreviousSalesTotal] = useState<any>();
  const [performanceNodeList, setPerformanceNodeList] = useState<any>([]);
  const [performanceDateNodeList, setPerformanceDateNodeList] = useState<any>(
    {},
  );
  const [programId, setProgramId] = useState("");
  const [isEmptyList, setIsEmptyList] = useState(false);
  const match: any = useRouteMatch();
  const idToken = getCookie("idToken");

  /* Get all location information */
  const getAllFilterLocation = async (searchName: any) => {
    fetchAllFilterLocations(searchName)
      .then((res) => {
        let locationList: any = [];
        /* Setting up the list of locations as needed to select locations. */
        if (!_.isEmpty(res.data.data)) {
          res.data.data.map((location: any) => {
            locationList.push({
              id: location.id,
              label: location.businessDisplayName,
            });
          });
        }
        const locationName = getFilterListFromArrayObject(
          locationList,
          match.params.locationId,
        );
        setLocationSelectorList(locationList);
        handleGetLocationProgram();
      })
      .catch(() => {
        setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
      });
  };

  /* Get all user information using API call and response data set to userList state. */
  const getUserInfo = async (locationId: any) => {
    try {
      const res = await fetchAllUserInfo(idToken, locationId);
      if (!_.isEmpty(res.data.data)) {
        const res = await fetchAllUserInfo(idToken, locationId);

        let arr: any = [];
        if (!_.isEmpty(res.data.data)) {
          Object.values(res.data.data).map((data: any) =>
            arr.push({ id: data.id, label: data.name }),
          );
        }
        if (!_.isEmpty(arr)) {
          setUserList((prevState: any) => [...prevState, ...arr]);
        }
      }
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  const handleGetLocationProgram = async () => {
    try {
      const { data } = await fetchLoyaltyProgramInfo(match.params.locationId);
      const programDetails: any = Object.values(data.data)[0];
      setProgramId(programDetails.programId);
      setIsGetLocationInfo(true);
    } catch (error) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };
function parseDateRange(input: any) {
  const startMatch = input.match(/date>=([\d-]+)/);
  const endMatch = input.match(/date<=([\d-]+)/);

  return {
    startDate: startMatch ? startMatch[1] : null,
    endDate: endMatch ? endMatch[1] : null,
  };
}
  const getCurrentPerformanceDate = async (filterData: any) => {
    try {
      const programIdFilterData = `${filterData}`;
     const date =   parseDateRange(programIdFilterData);
        // setCurrentStartDate(convertDateToMoment(range.selection.startDate));
          // setCurrentEndDate(convertDateToMoment(range.selection.endDate));
      const res = await fetchAllPerformanceDateInfo(
        idToken,
        match.params.locationId,
        programIdFilterData,
        programId,
      );
      if (res?.data?.data && Object.keys(res.data.data).length > 0) {
        const output = res?.data?.data.reduce((acc: any, item: any) => {
          const { reportDate, ...rest } = item;
          acc[reportDate] = { ...rest };
          return acc;
        }, {});
        setPerformanceDateNodeList(output);
        setIsEmptyList(false)
      } else {
        setPerformanceDateNodeList({})
        setIsEmptyList(true)
      }

      setCurrentStartDate(convertDateToMoment(date.startDate))
      setCurrentEndDate(convertDateToMoment(date.endDate))
        setIsOpenSkeletonLoading(false);

    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
        setIsOpenSkeletonLoading(false);
    }
  };
  const getCurrentPerformance = async (filterData: any) => {
    try {
      const programIdFilterData = `${filterData}`;
      const res = await fetchAllPerformanceInfo(
        idToken,
        match.params.locationId,
        programIdFilterData,
        programId,
      );

      setPerformanceNodeList(res.data.data);
      setIsLoadingIsLoadingPerformanceTotal(false);
      getCurrentPerformanceDate(filterData);
    } catch (err) {
      setError(ERROR_MESSAGE_UNEXPECTED_ERROR);
    }
  };

  useEffect(() => {
    document.title = "Sale - Dashboard";
    getAllFilterLocation("");
  }, []);

  // Get current filter data
  const handleFilterData = async (filterData: any, basedOnShift: boolean) => {
    await getCurrentPerformance(filterData);
  };

  /*Get location list API call after typing. */
  const handleLocationSelectorTypingList = (searchName: any) => {};

  const theme: CustomTheme = useTheme();

  return (
    <>
      <Hidden lgUp>
        <PageHeaderMobile />
      </Hidden>
      <Box>
        <Filter
          getFilterData={handleFilterData}
          locationSelectorList={locationSelectorList}
          getLocationSelectorTypingList={handleLocationSelectorTypingList}
          getUserInfo={getUserInfo}
          userList={userList}
          availableFilter={customerDashboardFilterObject}
          setFilterDetails={setFilterDetails}
          setPreviousStartDate={setPreviousStartDate}
          setPreviousEndDate={setPreviousEndDate}
          setCurrentStartDate={setCurrentStartDate}
          setCurrentEndDate={setCurrentEndDate}
          previousStartDate={previousStartDate}
          previousEndDate={previousEndDate}
          isGetLocationInfo={isGetLocationInfo}
          isChart={false}
          locationSelectedList={locationSelectedList}
          setLocationSelectedList={setLocationSelectedList}
          openFilterCard={openFilterCard}
          setOpenFilterCard={setOpenFilterCard}
          isWeekDateRange={true}
        />
        <DashboardDetailsInfoNode
          isLoading={isLoadingIsLoadingPerformanceTotal}
          performanceNodeList={performanceNodeList}
        />
        <ChartLoading
          isLoading={isOpenSkeletonLoading}
          currentDashboardNodeList={currentDashboardNodeList}
          previousDashboardNodeList={previousDashboardNodeList}
          paymentNodeList={performanceDateNodeList}
          previousPaymentNodeList={previousPaymentNodeList}
          previousStartDate={previousStartDate}
          previousEndDate={previousEndDate}
          currentStartDate={currentStartDate}
          currentEndDate={currentEndDate}
          ordersNodeList={ordersNodeList}
          previousOrdersNodeList={previousOrdersNodeList}
          averageNodeList={averageNodeList}
          previousAverageNodeList={previousAverageNodeList}
          platformNodeList={platformNodeList}
          previousPlatformNodeList={previousPlatformNodeList}
          modeNodeList={modeNodeList}
          previousModeNodeList={previousModeNodeList}
          channelNodeList={channelNodeList}
          previousChannelNodeList={previousChannelNodeList}
          isEmpty={isEmptyList}
          currentSalesTotal={currentSalesTotal}
          previousSalesTotal={previousSalesTotal}
          salesTotalNode={performanceNodeList}

        />
      </Box>
      <DefaultAlert
        open={!!error}
        handleClose={() => setError("")}
        message={error}
        severity="error"
      />
    </>
  );
};

export default withAuthority(CustomerDashboardPage, Authorities.SALE_READ);
